// lib/design-tokens.js
/**
 * Design Tokens - Système de design cohérent
 * Tous les tokens sont en rem/px pour cohérence
 */

export const tokens = {
  // 🎨 Couleurs sémantiques
  colors: {
    primary: {
      DEFAULT: 'rgb(15 23 42)', // slate-900
      hover: 'rgb(30 41 59)',   // slate-800
      light: 'rgb(148 163 184)', // slate-400
      bg: 'rgb(248 250 252)',   // slate-50
    },
    accent: {
      DEFAULT: 'rgb(139 92 246)', // purple-500
      hover: 'rgb(124 58 237)',   // purple-600
      light: 'rgb(233 213 255)',  // purple-200
      bg: 'rgb(250 245 255)',     // purple-50
    },
    success: {
      DEFAULT: 'rgb(34 197 94)',  // green-500
      bg: 'rgb(240 253 244)',     // green-50
      text: 'rgb(22 163 74)',     // green-600
    },
    warning: {
      DEFAULT: 'rgb(251 146 60)', // orange-400
      bg: 'rgb(255 247 237)',     // orange-50
      text: 'rgb(234 88 12)',     // orange-600
    },
    danger: {
      DEFAULT: 'rgb(239 68 68)',  // red-500
      bg: 'rgb(254 242 242)',     // red-50
      text: 'rgb(220 38 38)',     // red-600
    },
    info: {
      DEFAULT: 'rgb(59 130 246)', // blue-500
      bg: 'rgb(239 246 255)',     // blue-50
      text: 'rgb(37 99 235)',     // blue-600
    },
  },

  // 📏 Spacing (multiples de 4)
  spacing: {
    xs: '0.5rem',   // 8px
    sm: '0.75rem',  // 12px
    md: '1rem',     // 16px
    lg: '1.5rem',   // 24px
    xl: '2rem',     // 32px
    '2xl': '3rem',  // 48px
    '3xl': '4rem',  // 64px
  },

  // 🔲 Radius (cohérence)
  radius: {
    sm: '0.5rem',   // 8px - inputs, badges
    md: '0.75rem',  // 12px - buttons, cards small
    lg: '1rem',     // 16px - cards standard
    xl: '1.5rem',   // 24px - cards premium
    '2xl': '2rem',  // 32px - modals
    full: '9999px', // pills
  },

  // 🌑 Shadows (3 niveaux)
  shadow: {
    sm: '0 1px 3px 0 rgb(0 0 0 / 0.1)',
    md: '0 4px 12px 0 rgb(0 0 0 / 0.1)',
    lg: '0 10px 40px -10px rgb(0 0 0 / 0.15)',
    premium: '0 20px 60px -15px rgb(0 0 0 / 0.2)',
  },

  // 📝 Typography
  font: {
    size: {
      xs: '0.75rem',   // 12px
      sm: '0.875rem',  // 14px
      base: '1rem',    // 16px
      lg: '1.125rem',  // 18px
      xl: '1.25rem',   // 20px
      '2xl': '1.5rem', // 24px
      '3xl': '2rem',   // 32px
      '4xl': '2.5rem', // 40px
    },
    weight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      black: 900,
    },
  },

  // 🎭 Transitions
  transition: {
    fast: '150ms',
    base: '200ms',
    slow: '300ms',
  },
}

// Export pour utilisation directe
export default tokens
